import { memo } from 'react';
import { Typography } from '@mui/material';

// An app version we only partly identified still earns a row, so the gap says what is missing
// rather than leaving a blank cell that reads as a rendering bug.
const MissingValueText = ({ label, sx }) => (
  <Typography
    component="span"
    sx={{ color: '#7E8794', fontStyle: 'italic', fontSize: 'inherit', ...sx }}>
    {`No ${label} provided`}
  </Typography>
);

export default memo(MissingValueText);
